module.exports = __webpack_public_path__ + "media/home1.4f3d5067.mp4";